<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="/css/forms.css" />

</svelte:head>

<script>

    import { onMount } from "svelte";
    import { setContext, getContext } from "svelte";
    import { get } from "svelte/store";
    import { sessionId, onboardingInfo } from "../../utils/store";
    import PaymentModule from "../admin/payment.svelte";

    import {
        errorReasons,
        updateUserStatus,
        logout
    } from "../api.svelte";

    import {
        getLocalSessionId,
        getLocalUserStatus,
        getStatusRoute,
        sessionCleanup
    } from "../../utils/session";


    const router = getContext('router');

    let localOnboardingInfo = get(onboardingInfo);

    if (Object.keys(localOnboardingInfo).length === 0) {

        localOnboardingInfo = JSON.parse(localStorage.getItem('konboardinginfo'));
    }

    let currency = localOnboardingInfo['currency'];
    let tier = localOnboardingInfo['tier'];

    let vatPercentage = 7.7;

    let subscriptionData = {
        'status': 'pending'
    };


    onMount(() => {

        let localSessionId = getLocalSessionId();
        let localStatus = getLocalUserStatus();

        if (!localSessionId || !localStatus) {

            router.route('/login');
            return;

        }

        if (localStatus !== 'onboarding_payment') {

            router.route(getStatusRoute(localStatus));
            return;

        }

        if (!localOnboardingInfo) {

            router.route('/plans');

        }

    });

    let orderComplete = (evt) => {

        localStorage.setItem('kstatus', 'onboarding_locations');
        updateUserStatus('onboarding_locations');

        localStorage.removeItem('konboardinginfo');

        setTimeout(() => {

            router.route('/locations');

        }, 3000);

    };

    let logoutHandler = () => {

        logout().then((_) => {

            sessionId.set('');
            sessionCleanup();
            router.route('/login');

        });

    };

    let backHandler = () => {

        router.route('/plans');
    };

</script>


<div class="onboarding-back" on:click={() => backHandler()}>

    <img src="/images/icons/nav/back.svg" alt="" />
    <span>Zurück zur Auswahl</span>

</div>

<div class="onboarding-logout" on:click={() => logoutHandler()}>

    <img src="/images/icons/nav/logout.svg" alt="" />
    <span>Logout</span>

</div>

<div class="onboarding-text">

    <div class="headline-styler"></div>

    <h2>
        Fast fertig: Wieviele Standorte
        möchten Sie analysieren?
    </h2>

    <ul class="keyosh-list">

        <li>
            Sie zahlen bei uns für Standorte - physische Verkaufsstellen, wie ein Restaurant oder Hotel.
        </li>

    </ul>

</div>

<PaymentModule
        currency={currency}
        tier={tier}
        vatPercentage={vatPercentage}
        subscriptionData={subscriptionData}
        on:complete={orderComplete}
        showCoupon={true} />

<style>

    .onboarding-text {
        margin-right: 21.66vh;
    }

    @media screen and (max-width: 1024px) {

        .onboarding-text {
            margin-top: 14vw;
            margin-right: 0;
        }

    }

</style>
